<script>
import Forms from '@/components/forms'
import { mapGetters } from 'vuex'

export default {
  name: 'add-to-cart-form',
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: vm => ({
    quantity: 1,
    showCustomForm: false,
    specifications: {}
  }),
  watch: {
    visible: {
      handler (v) {
        if (this.visible)
          this.specifications = {
            ...this.specifications,
            item_id: this.product.id
          }
        else {
          this.specifications = {}
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('auth', ['resolveCustomerAccountId']),
    customForm () {
      const { webshop_custom_form } = this.product
      if (
        Object.prototype.hasOwnProperty.call(Forms, webshop_custom_form) &&
        Forms[webshop_custom_form].component
      )
        return Forms[webshop_custom_form].component
      return null
    }
  },
  methods: {
    onCancelHandler () {
      this.$emit('update:visible', false)
      this.specifications = {}
    },
    onCustomFormComplete (data) {
      this.showCustomForm = false
      this.specifications = data
      this.addToCart()

      this.$emit('update:visible', false)
      this.$router.push({ name: 'cart.list', query: { t: Date.now() } })
    },

    async addToCart () {
      let { web_shop_allow_grouping = false, webshop_custom_form } =
        this.product
      let {
        reference,
        file_id,
        shipping_address_id,
        images,
        comments,
        specs = {}
      } = this.specifications

      const customer_account_id = this.resolveCustomerAccountId(this.specifications)

      if (!customer_account_id) {
        this.$root.$bvToast.toast('Please select a customer before adding to cart.', {
          title: 'Customer required',
          solid: true,
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-center'
        })
        return
      }

      let item = await this.$store.dispatch('cart/addToCart', {
        data: {
          ...this.specifications,
          type: webshop_custom_form,
          item_id: this.product.id,
          quantity: this.quantity,
          allow_grouping: webshop_custom_form ? false : web_shop_allow_grouping,
          form_data: { ...specs },
          reference,
          file_id,
          shipping_address_id,
          customer_account_id,
          comments
        },
        web_form_files: images
      })
      this.specifications = {}
      this.$root.$bvToast.toast(`Item added to Cart.`, {
        title: 'Item Added',
        solid: true,
        variant: 'info',
        autoHideDelay: 1000,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })
    }
  }
}
</script>
<template>
  <b-modal
    :visible="visible"
    v-on:change="$emit('update:visible', $event)"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
    hide-footer
    hide-header
    body-class="p-2"
  >
    <h6 class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light">
      {{ product.short_description }}
    </h6>
    <component
      :is="customForm"
      v-model="specifications"
      v-on:complete="onCustomFormComplete"
      v-on:cancel="onCancelHandler"
    />
  </b-modal>
</template>
